export default "__VITE_ASSET__VNmjEUGt__"